import { HttpClient } from './httpClient'
import { fetchClientInstanceId } from '@/utils/clientInstance'
import type { AuthStoreInterface } from '@/stores/auth'

let _supportAgentClient: HttpClient | null = null

export function getSupportAgentClient(authStore: AuthStoreInterface): HttpClient {
  if (!_supportAgentClient) {
    const clientInstanceId = fetchClientInstanceId()
    _supportAgentClient = new HttpClient(
      import.meta.env.VITE_SUPPORT_AGENT_API_HOST,
      clientInstanceId,
      undefined
    )
  }
  _supportAgentClient.setAuthStore(authStore)
  return _supportAgentClient
}

export function setSupportAgentClient(client: HttpClient): void {
  _supportAgentClient = client
}

